import { PermanentJobsApi } from '../clients';
import { IRetryBillingResultEntity } from '../types';

export const retryBilling = async (): Promise<IRetryBillingResultEntity[]> => {
  return PermanentJobsApi.retryBilling();
};
